module.exports = __webpack_public_path__ + "img/temperature-humidity-sm.374edd99.svg";